export default __webpack_public_path__ + "static/trip-9c9fee2cac7723b89f3d5621a0e81fe0.webp";